import React from 'react';
import PropTypes from 'prop-types';

import CONSTANTS from '../../../constants/index';
const SignUpHelp = ({ style }) => (
  <div className={`layout--column layout-align--center-center`} style={style}>
    <span
      style={{ fontSize: '1.4rem', lineHeight: '1.7rem', color: '#464646' }}
    >
      Need help signing up?
    </span>
    <strong>
      <a
        href={`mailto:${CONSTANTS.QM_SUPPORT_EMAIL}`}
        style={{
          fontSize: '1.4rem',
          lineHeight: '1.7rem',
          fontWeight: 'bold',
          color: '#009A52',
          textDecoration: 'none',
        }}
      >
        Contact Us
      </a>
    </strong>
  </div>
);

SignUpHelp.propTypes = {
  style: PropTypes.object,
};

export default SignUpHelp;
